import React from "react";
import { Clock } from "lucide-react";
import { Constants } from "../utils/constants";

const HTimeSection = () => {
  return (
    <div>
      <div className="flex items-start gap-3">
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: Constants.HOST_EXPERIENCE_BASE_COLOR }}
        >
          <Clock className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1">
          <div className="text-gray-900 font-medium mb-1">
            Thursday, December 5 &nbsp;&nbsp; 12:00pm &nbsp;&nbsp; – &nbsp;&nbsp; 1:00pm
          </div>
          <div className="text-gray-500 text-sm mb-2">Time zone – Does not repeat</div>
          <button
            className="font-medium hover:underline text-sm"
            style={{ color: Constants.HOST_EXPERIENCE_BASE_COLOR }}
          >
            Find a time
          </button>
        </div>
      </div>
    </div>
  );
};

export default HTimeSection;
